import React from 'react';
import PropTypes from 'prop-types';

import PromoContent from './PromoContent';

const PromoFrameworkOne = props => {
  const { promos } = props;

  return promos.map(promo => {
    const { title, subtitle, description } = promo;

    return (
      <PromoContent
        key={title}
        title={title}
        subtitle={subtitle}
        description={description}
      />
    );
  });
};

PromoFrameworkOne.propTypes = {
  promos: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      description: PropTypes.string
    })
  )
};

export default PromoFrameworkOne;
